import DataKeys from 'k8s/DataKeys'
import getDataSelector from 'core/utils/getDataSelector'

export const eksAmiTypesSelector = getDataSelector<DataKeys.EksAmiTypes>(DataKeys.EksAmiTypes)
